(() => {
  const script = document.currentScript;
  const epoch = Number(script?.dataset.waOfferClock) * 1000 || Date.now();
  const anchor = performance.now();
  const params = new URLSearchParams(location.search);
  const preview = params.get('preview_fuenf') === '1' && params.get('preview_fuenf_phase') === 'collection';
  const update = () => {
    const now = epoch + performance.now() - anchor;
    let active = false;
    document.querySelectorAll('[data-wa-october-offer]').forEach(el => {
      const show = preview || (now >= Number(el.dataset.waOfferStart) * 1000 && now < Number(el.dataset.waOfferEnd) * 1000);
      if (el.hidden === show) el.hidden = !show;
      active ||= show;
    });
    document.documentElement.classList.toggle('wa-october-active', active);
  };
  update();
  setInterval(update, 1000);
  document.addEventListener('shopify:section:load', update);
  document.addEventListener('visibilitychange', update);
})();
